<template>
  <div  >





 
<div v-if='loginbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='loginbox=false'></div>
  <div v-if="logintype=='send'" style="width:470px;position:relative;z-index:100000000">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='login'>
              <div class="d-flex align-items-center justify-content-between mt-md-0 mt-3">
                <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">Enter Mobile Number</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>
              </div>


                            <div style="position: relative;    background: #FFFFFF!important;
    border: 1px solid #E7E5F2!important;
    border-radius: 5px;!important" class='labhead  d-flex align-items-center '  id="hideinputl">
                              <p style="padding-left:10px;color:rgb(11, 10, 35);font-weight:600" class="p91">+91 </p><span style="height:50px;width:1px;background:rgb(231 229 242 / 60%);margin:0px 15px;"></span>
                              
                              <div style="flex:1" class="d-md-block d-none">
                                
                        
                            <input autofocus=""  type="text" placeholder="Enter your mobile number" name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
                           
                                  </div>


                                     

                                      <div style="flex:1;position:relative" class="d-md-none d-block">
                                
                         
                             <input  autofocus=""  type="number" id="phonenumber" placeholder="Enter your mobile number"  name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
 
                    
                           
                                  </div>




                        





                          </div>
                              <div id="recaptcha-container"></div>

                   

   <div class="d-flex align-items-center justify-content-center martp" style="" v-if='!sendotpclicked' >

                                <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer " v-if='phone.length==10'  >Send Otp</button>
                                <button disabled=""  class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer "   v-if='phone.length!=10' >Send Otp</button>
                              </div>

                               <div class="d-flex align-items-center justify-content-center martp" v-if='sendotpclicked' >

                                  <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer "  >
                                  <img src="./images/signinloader.svg" style="width:30px">
                                </button>
                              </div>
                              

            </form>
          
        </div>
    
  </div>











  <div v-if="logintype=='otp'" style="width:500px;position:relative;z-index:100000000">
        
        <div  class="loginwrapper">

            

              <div class="d-flex align-items-center justify-content-between  mar40"  >

                 <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">OTP Verification</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>



               
              </div>

                      
       

            <div  class="otpboxes  " style="">
    <v-otp-input
      inputClasses="otp-input"
      :numInputs="6"
       separator=""
      :shouldAutoFocus="true"
                  @on-complete="subotp"
       
    />
  </div>
                           

                     
 

<div class="d-flex align-items-center justify-content-center">
  

      <button   class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer " v-on:click='subotps'   v-if='otpenterd' >Login</button>
      </div>
 

  <p v-if='perrs' style="text-align:center;color:red">{{otptext}}</p>
 
                 
                   
 
                              

       
          
        </div>
    
  </div>




</div>





 





  <div     >




<div v-if='mobilesearch'>
  

<div style="background:#fff;height:100vh " class="d-md-none d-block" >
  

<div style="padding:15px;position:relative" class="d-flex align-items-center justify-content-center">
  <img v-on:click='mobilesearch=false' src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iIzFBMTgxRSIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIuNjkgMy44OGMuMzk2LS4zODYgMS4wMjktLjM3OSAxLjQxNS4wMTYuMzU2LjM2NC4zNzguOTMyLjA2OCAxLjMybC0uMDg0LjA5NC04LjU1IDguMzZjLS4zNTkuMzUtLjkxNS4zNzgtMS4zMDUuMDgxbC0uMDkzLS4wODEtOC41NS04LjM2Yy0uMzk1LS4zODYtLjQwMi0xLjAyLS4wMTYtMS40MTQuMzU2LS4zNjUuOTIzLS4zOTkgMS4zMTktLjA5OGwuMDk1LjA4MiA3Ljg1MSA3LjY3NSA3Ljg1LTcuNjc1eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2IC05NSkgdHJhbnNsYXRlKDE2IDk1KSB0cmFuc2xhdGUoMSAzKSByb3RhdGUoOTAgNC44NCA4Ljc3NSkiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjEuNzggNy43NzVjLjU1MiAwIDEgLjQ0OCAxIDEgMCAuNTEzLS4zODYuOTM2LS44ODMuOTkzbC0uMTE3LjAwN0guNjZjLS41NTIgMC0xLS40NDgtMS0xIDAtLjUxMy4zODYtLjkzNi44ODMtLjk5M2wuMTE3LS4wMDdoMjEuMTJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYgLTk1KSB0cmFuc2xhdGUoMTYgOTUpIHRyYW5zbGF0ZSgxIDMpIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=" style='height:24px;width:24px;min-width:24px'>
<div class="inputboxui nopos   " style="z-index:1000000000;margin-top:0px;margin-left:10px;flex:1;padding-left:7px"  >

    <div v-if='searching' style="position:absolute;left;bottom:0px;height:2px;width:60px;background:#216EB4;   animation: animatename 3s linear infinite;"></div>

   <div class="actualinputbox">





 <vue-autosuggest
        v-model="query"
        :suggestions="filteredOptions"
        
        
        @input="onInputChange"
        @selected="onSelected"
 
        :get-suggestion-value="getSuggestionValue"
        :input-props="{id:'autosuggest__input', placeholder:'Search for products...',class:'form-control searchinput',autofocus:'true'}">


        <div slot-scope="{suggestion}" style="display: flex; align-items: center;cursor:pointer">
            <i class='bx bx-search searchsize '   style="color:#B3B3B3!important;margin-right:10px;display:none" ></i>
            <div style="width:35px;border-radius:4px;margin-right:10px;overflow:hidden">
              <img :src='suggestion.item.imageurl' class="img-fluid" />
            </div>

          <div style="{ display: 'flex', color: '#1a181e'}">{{suggestion.item.name}} </div>


        </div>
      </vue-autosuggest>

     
  </div>

<label for='autosuggest__input' style="margin:0px;padding:0px;line-height: 0px!important;">
  

    <i v-if='query.length>0' v-on:click="removequery" style="cursor:pointer"  class='bx bx-x searchsize' ></i>
</label>
  
</div>



</div>
</div>


</div>


 
<div  v-else style="" class="heads"> 


 




<div style="z-index: 10000;position: fixed;bottom: 0;left: 0;right: 0;box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);padding:10px 27px;background: #fff;" class="d-md-none d-flex align-items-center justify-content-between">


  



  <div

 class="botactive navclass" 

  >


    <router-link to="/" style='text-decoration:none'>

 <img src="./images/files/home.svg" style="transform:translateY(-1px)" >



</router-link>
</div>


 
 

   <div v-bind:class="[{ botactive: $route.path=='/'+$route.path.split('/')[1]+'/bag'  },{ botnotactive: !($route.path=='/bag') },{navclass:true}]" style="position:relative">
    <router-link to="/bag" style='text-decoration:none'>
<div style="width:16px;height:16px;background:#EB3838;border-radius:50%; z-index:10000;   position: absolute;
    top: 3px;
    right: 4px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:10px;font-weight:700">{{rendercartlength}}</span>
</div>
 <img src="./images/files/bagbottom.svg"  style="width:20px;transform:translateY(-1px)" >

  </router-link>
  </div>

   <div v-bind:class="[{ botactive:$route.path=='/'+$route.path.split('/')[1]+'/account'  },{ botnotactive: !($route.path=='/account') },{navclass:true}]" v-on:click='account'>
        

 <img src="./images/files/user.svg" style="width:20px;transform:translateY(-1px)"   >
 
  </div>
   
</div>




 


<div  class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper" style="position:sticky;top:0px;background:#fff;z-index:1000000000000">
  <div class="container  ">

  <div class="headerui     ">
    <router-link  to="/" style='text-decoration:none'>
<div class="d-flex align-items-center mr-4  logowrapper">
  
  <img src="./images/finallogo.png" style="" class="logohigh">
</div>
</router-link>


<div style="position:fixed;top:0;left:0;right:0;bottom:0px;background:rgba(0,0,0,0.3);z-index:100000000;cursor:pointer"  class="d-md-block d-none" v-if='opacitybox'  v-on:click='opacitybox=false' ></div>


 



<div class="inputboxui    d-md-flex d-none " style="z-index:1000000000" v-on:click='opacitybox=true'>

    <div v-if='searching' style="position:absolute;left;bottom:0px;height:2px;width:60px;background:#216EB4;   animation: animatename 3s linear infinite;"></div>

  <i class='bx bx-search searchsize'   style="color:#cfcfd4!important" ></i>
  <div class="actualinputbox">





 <vue-autosuggest
        v-model="query"
        :suggestions="filteredOptions"
        
        
        @input="onInputChange"
        @selected="onSelected"
        :get-suggestion-value="getSuggestionValue"
        :input-props="{id:'autosuggest__input', placeholder:'What are you looking for?',class:'form-control searchinput'}">


        <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
            <i class='bx bx-search searchsize '   style="color:#B3B3B3!important;margin-right:10px;display:none" ></i>
            <div style="width:35px;border-radius:4px;margin-right:10px;overflow:hidden">
              <img :src='suggestion.item.imageurl' class="img-fluid" />
            </div>

          <div style="{ display: 'flex', color: '#1a181e'}">{{suggestion.item.name}} </div>


        </div>
      </vue-autosuggest>


     
  </div>

<label for='autosuggest__input' style="margin:0px;padding:0px;line-height: 0px!important;">
  

    <i v-if='query.length>0' v-on:click="removequery" style="cursor:pointer"  class='bx bx-x searchsize' ></i>
</label>
  
</div>



<!--mobile -->


<div class="inputboxui  d-md-none d-none  " v-on:click='mobilesearch=true'>


  <i class='bx bx-search searchsize' style="color:#B9B9C1" ></i>
  <div class="actualinputbox">


    <input type="text" class="form-control searchinput" v-on:focus='mobilesearch=true' placeholder="What are you looking for?"  name="">
    
  </div>
  
</div>
<!--mobile -->


<!--mobile -->

 
<!--mobile -->







<div class="d-flex align-items-center  navwrapper  ml-3   ">
  

  <div class="d-none align-items-center contactwhatsapp" style="">
    
    <img src="https://cdn.usbrandcolors.com/images/logos/whatsapp-logo.svg" style="width:20px;margin-right:6px;min-width:20px;">

 <p style="font-weight:600;color:#fff;font-size:13px">WhatsApp</p>

  </div>
 
  <router-link    to="/bag"  style='text-decoration:none'>
  <div class="d-flex align-items-center navitem pl-4 ml-4" style="position:relative">
    
          <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>


    <div style="width:16px;height:16px;background:#EB3838;border-radius:50%;    position: absolute;
    top: 2px;
    right: 10px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:11px;font-weight:600">{{rendercartlength}}</span>
</div>



 <svg width="17" height="20" viewBox="0 0 17 20" fill="#0B0A23" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.7" d="M15 5.83333H11.6667V3.33333C11.6667 1.4925 10.1742 0 8.33333 0C6.4925 0 5 1.4925 5 3.33333V5.83333H1.66667L0 20H16.6667L15 5.83333ZM5.83333 3.33333C5.83333 1.955 6.955 0.833333 8.33333 0.833333C9.71167 0.833333 10.8333 1.955 10.8333 3.33333V5.83333H5.83333V3.33333ZM5 7.5V8.75C5 8.98 5.18667 9.16667 5.41667 9.16667C5.64667 9.16667 5.83333 8.98 5.83333 8.75V7.5H10.8333V8.75C10.8333 8.98 11.02 9.16667 11.25 9.16667C11.48 9.16667 11.6667 8.98 11.6667 8.75V7.5H13.5183L13.9108 10.8333H2.75667L3.14917 7.5H5Z" fill="#0B0A23"/>
</svg>

 


  </div>
</router-link>
  <div class="d-flex align-items-center    " style="position:relative;padding-left:50px"  >
      
      <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>

      <p class="mya" style="color: #0B0A23;

opacity: 0.8;font-weight: 500;
font-size: 14px;" v-on:click='account'>My Account</p>

<div v-if='user' style="position:absolute;top:0px;left:50%;transform:translateX(-50%);padding-top:40px;cursor:pointer" class="opanav">


  <div style="width:170px;background:#fff;border-radius:4px;box-shadow:0 0 10px rgba(0,0,0,0.1)">

    <router-link to='/whishlist' style='text-decoration:none'>
    <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Wishlist</p>
  </router-link>
   <router-link to='/account' style='text-decoration:none'>
       <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Account</p>
     </router-link>
          <p class="navhover"   v-on:click='logout' style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Logout</p>
  </div>
</div>


  </div>







</div>

</div>

  </div>
  
</div>





 







<!--- header -->




 

<div class="  pt-md-4 pb-md-4 pt-3 pb-3  mb-4 headerwrapper d-md-none d-flex" style="position: sticky;
    top: 0;
    z-index: 100000000;    padding-left:  8px; padding-right:  8px"> 
  <div class="container  " style="padding:0px 8px;">

  <div class="headerui     ">
  
 


<div class=" d-flex align-items-center ">
 
  <div style="margin-left:15px">
      <p class="categorytext  " style="margin:0px;font-size:16px;font-size: 20px;
 font-weight:700;


color: #0B0A23;" >{{$route.params.categoryname}}</p>
 
  </div>
</div>

<div>
    
    <div class="d-flex align-items-center ">
      

 
      

 

 

 


    </div>

</div>


 
 

</div>

  </div>
  
</div>

 






<div  v-if='loadstatus && theme==3' >

</div>


<div  v-else-if='loadstatus && theme==2' >






 

</div>



<div v-else-if='loadstatus && theme==1' >


 


<div class="pt-md-4 pb-md-5 pt-0 pb-3  headerwrapper2 mt-md-2 mt-0" style="">
  <div class="container   " >
  <div class="   ">



 

<div class="d-md-flex d-none align-items-center mt-md-5 mb-md-5 mb-5 mt-md-3 mt-0 m17" >
  
  <router-link to="/" style='text-decoration:none' >
  <svg width="21"   height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>
</router-link>
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >About Us
</p>



</div>




  
 
 




  <div style="">
     <h2 class="d-md-none d-block" style="text-align:center;color:#000;font-weight:700;font-size:30px;margin-bottom:20px">About Sayra</h2>

    <img src="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/About%20us%203.jpg?alt=media&token=256ba2f8-3458-4066-b8d4-22789e9e237b" style="width:100%">
  </div>
    <div class="container-fluid " style="padding: 0;margin: 0">
      <div style="max-width:700px;margin:0px auto">
     
      
    </div>
      <div class="row mt-5 justify-content-center">


 <div class="col-md-8">
   <div>
     <p style="font-size:18px;font-weight:400;color:#333;margin-bottom:20px;line-height:35px ">Welcome to sayra Apparels Pvt Ltd. We’re dedicated to giving you the best of dresses and other items, with a focus on trending fashion in India. Our store has come a long way from its beginnings. We now serve customers all over the world and are thrilled that we’re able to turn our passion into our own website</p>

      <p style="font-size:18px;font-weight:400;color:#333;margin-bottom:20px;line-height:35px ">SAYRA is a global online fashion retailer website. Our constant endeavor is to provide a fashionable, trendsetting, up-to-the-minute collection of ready-to-wear suits, Dress, lehengas, and contemporary indo-western outfits, accessible through an easy-to-explore, user-friendly e-commerce platform. SAYRA also brings together statement accessories to help accentuate your look and serve as a complete online fashion solution.</p>
      <p style="font-size:18px;font-weight:400;color:#333;margin-bottom:20px;line-height:35px ">Setting us apart is our expert team of tailors who will help and guide you personally for your customized look, fit, and style. Our thoughtfully designed measurement guide and style illustrations will help you communicate accurate body measurements for your perfectly fitting garment delivered right to your doorstep.</p>
      <p style="font-size:18px;font-weight:400;color:#333;margin-bottom:20px;line-height:35px ">Exclusive to the website is our coveted Couture section. Couture houses the most premium selection of ethnic Indian wear, bridal wear, and contemporary ensemble. Coupled with our customizing services and premium packaging, our Couture section is the one-stop source for prime clothing that online fashion has to offer.</p>
      <p style="font-size:18px;font-weight:400;color:#333;margin-bottom:20px;line-height:35px ">Bringing in a plethora of ethnic options for you to take your pick from SAYRA. We are created for everyone who is energetic, fun, and high-spirited. Amalgamating Indian prints with bright hues, the brand will promise to be a go-to choice for both, work and play.</p>
      <p style="font-size:18px;font-weight:400;color:#333;margin-bottom:20px;line-height:35px ">I hope you will enjoy our collection as much as enjoy offering them to you. If you have any questions or comments, please don’t hesitate to contact us.</p>
      
   </div>
 </div>




   




      </div>
    </div>

   
  
 














 
 </div>

  </div>
  
</div>
 
</div>





<div  v-else >



    <div  style="height:calc(100vh - 94px);background:#fff; " class="d-md-flex d-none align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>




    <div  style="height:calc(100vh - 54px);background:#fff; " class="d-md-none d-flex align-items-center justify-content-center">
   
   <div style="width:80px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>





 

      </div>




 
 


 


 














  


 


   
 


 <div style="background: #262626;" class="p-5 mt-5">
   
   <div class="container py-5">
     <div class="row justify-content-center">



      
       <div class="col-md-4"  >
         <div>
             
 


 <div style="margin-left:-8px">
       <img  src="./images/finallogo.png" class="img-fluid" style="position:relative;height:40px" >

 </div>
<p style="font-weight: 400;font-size: 15px;margin:15px 0px;color: #FFFFFF;line-height: 26px;font-weight:600;display:none">SAYRA APPARELS PVT LTD</p>
 
 <h2 style="color:#fff;font-weight:600;font-size:18px;margin-top:22px">Get in Touch</h2>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Monday - Saturday</p>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">9:00 AM to 6:00 PM</p>
<a href="tel:+918433408665" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">+91 8433408665</a>
<a href="mailto:support@sayra.in" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">support@sayra.in</a>
<div class="d-none align-items-center   mt-4">
  <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;margin-right:13px;min-width:30px;background:#fff;margin-left:0px">
      <i class='bx bxl-facebook' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-instagram' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-youtube' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-twitter' style="color:#1B1A31;font-size:20px"></i>
  </div>
</div>

         </div>
       </div>


       <div class="col-md-4 mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">Customer Help</h2>
           <div>
             <router-link  to='/termsconditions' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Terms & Condition</router-link>


              <router-link   to='/privacypolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Privacy Policy</router-link>
               <router-link   to='/refundpolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Refund Policy</router-link>
                <router-link  to='/shipping'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Shipping Policy</router-link>
              <router-link  to='/returnexchange'  style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Return & Exchange</router-link>

                       <router-link to="/about"    style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">About Us</router-link>
           </div>
         </div>
       </div>
      
       <div class="col-md-4  mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">My Account</h2>
           <div>
             <router-link to='/bag' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">View Cart</router-link>

              <a href="https://tracklite.in/c/sayraindia" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Track My Order</a>

               <router-link to='/contact' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Contact Us</router-link>
            </div>
         </div>
       </div>
           


           
         </div>




       </div>

     </div>

   </div>
 </div> 
 



 








 
 </div>

  </div>
  
</div>
</template>
</div>

 </div>



<!--footer -->

 




 
 
  </div>
</div>
</div>
</template>

<script>
    var coderesult
 import firebase from 'firebase'
   import axios from 'axios'
 
const fb = require('./firebaseconfig.js')

export default {
 

        props: ['loadstatus','info','products','category','deals','categoryall','addcart','uids','carts','theme'],

  data () {

        return{


       query: "",
      selected: "",
      filteredOptions:[],
      mobilesearch:false,
      name:'',
      submitloader:false,
      message:'',phone:'',

      mobile:'',
      email:'',
      searching:false,
      opacitybox:false,
      sentlead:false,
      customotp:90922,
       sendotpclicked:false,
       otpenterd:true,
       otpvalue:'',
      suggestions: [
        {
          data: [
             
          ]
        }
      ], limit: 10,





 phone:'',
            otp:'',
            logintype:'send',
            phonetext:'Phone number',
            otptext:'OTP',
            errs:false,
            disp:'none',
            otpdes:true,
            perrs:false,
            user:false,
            loginbox:false,
  

         categoryproduct:[],
         user:false

        }
     
    
  },
  created(){
 
 window.scrollTo(0,0)
 
     if(firebase.auth().currentUser){


  this.user=true
 }else{
    this.user=false
 }


   },
   computed:{
     rendercartlength(){

var cartlength=0
        var x=this.carts.forEach((itm)=>{

           cartlength=Number(itm.quantity)+cartlength
        })
        return cartlength

    },

categoryproducts(){



var deals=[]

 
 for (var key in this.categoryall) {

 




  var loopsep=this.categoryall[key].filter((item)=>{


  if(item.deals){
          
 
   return  item
          
      }







  })

deals=[
...deals,
...loopsep
]
 
 
  }
 
 

  return deals 


 
 

}
   },
   methods:{
   sendlead(){
    var vm=this
 var ms = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        vm.submitloader=true
    var x=new Date().getDate()+' '+ms[new Date().getMonth()]+' '+new Date().getFullYear()
      var x={
      name:this.name,
      email:this.email,
      message:this.message,
      mobile:this.phone,
      createdon:new Date(),
      datetext:ms
      }


      fb.db.collection('adminportal').doc('fIO4aN5mudetdopvy7OADlHSTB92').collection('leads').add({
        ...x
      }).then(()=>{

        vm.submitloader=false
        vm.sentlead=true
        setTimeout(()=>{
 vm.sentlead=false
        },3000)
        vm.email=''
           vm.phone=''
              vm.message=''
                 vm.name=''
      })
   },
  clickHandler(item) {
 
    },
    onSelected(item) {
 

 

 
  this.selected = item.item;
  this.opacitybox=false
 
 
 this.$router.push({ path: '/productsdetails/'+item.item.category+'/'+item.item.ids })


   },
   removequery(){

      this.suggestions[0].data=[]

        this.filteredOptions = [{

         data:  []

        }];

this.searching=false
 
 this.query=''
   },
   async onInputChange(text) {

 
 

 

  this.suggestions[0]=[
  ]



        this.filteredOptions = [{
         data:   []
        }
        ];

 if(text.length>2){


 this.searching=true
const { docs } =     await fb.db.collection('adminportal').doc(this.uids).collection('products').where('searchableindex', 'array-contains',text.trim().toLowerCase()).limit(5).get()

   this.suggestions[0].data=[]

        this.filteredOptions = [{

         data:  []

        }];

 
 docs.map((doc) => {
 


 

  this.suggestions[0].data.push({...doc.data(),ids:doc.id});



        this.filteredOptions = [{
         data:   this.suggestions[0].data
        }
        ];



 });

 this.searching=false

      


 }
 

      
    },

    /**
     * This is what the <input/> value is set to when you are selecting a suggestion.
     */

    getSuggestionValue(suggestion) {
 

      return suggestion.item.name 
    },
    focusMe(e) {
      console.log(e) // FocusEvent
    },
    

 

  account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path:  '/account' })

 }else{
this.loginbox=true
 }
    },
    

    closeloginbox(){
      this.loginbox=false
      this.logintype='send'
    }
   ,
 subotp(value){
      this.otpenterd=true
      this.otpvalue=value
    },

subotps(value){

var vm=this;

var already=false

 
if(vm.customotp==vm.otpvalue){



fb.db.collection("client5").where("email", "==",'+91'+vm.phone+'@sayra.com' )
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {

          already=true
            console.log(doc.id, " => ", doc.data());
        });


        if(already){



          fb.auth.signInWithEmailAndPassword('+91'+vm.phone+'@sayra.com', '+91'+vm.phone,)
  .then((userCredential) => {
    // Signed in 
    var user = userCredential.user;

           
       
 vm.logintype='send'
 vm.loginbox=false
 
 
       vm.phone=''




var address=[]

 
 fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').orderBy('date','desc').onSnapshot(querySnapshot=>{
 address=[]
 var i=0;
    querySnapshot.forEach((doc)=> {
      
 
 

      if(i==0){
            vm.selectedaddress={
              id:doc.id,
              ...doc.data(),selected:true
            }
          address.push({id:doc.id,...doc.data(),selected:true})
        }else{
            address.push({id:doc.id,...doc.data(),selected:false})
        }
        i++
    
        
    }) 
 
 

vm.address=[
...address
]

})


 
  })
   



        }else{

          fb.auth.createUserWithEmailAndPassword('+91'+vm.phone+'@sayra.com', '+91'+vm.phone,)
  .then((userCredential) => {
    // Signed in 
    var user = userCredential.user;

    user.updateProfile({
  displayName:'+91'+vm.phone
 })

           

           fb.db.collection("client5").doc(fb.auth.currentUser.uid).set({
            email:'+91'+vm.phone+'@sayra.com'
           })
       
 vm.logintype='send'
 vm.loginbox=false
 
vm.$router.push({ path: '/account' })

       vm.phone=''



 
  })
   



        }
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });













}else{
  vm.perrs=true
      vm.otptext='Invalid Otp'
      vm.otpvalue=''
      console.log('errorr')
       console.log(error.message);
       vm.otpenterd=false
       setTimeout(()=>{
         vm.perrs=false
       },3000)

}
 
 
 
  


},

 login(){

 
 


var vm=this
var randotp=Math.floor(100000 + Math.random() * 900000);
this.sendotpclicked=true
vm.customotp=randotp

  axios.get('https://www.fast2sms.com/dev/bulkV2?authorization=bVo7GRmXxBWqwS3AiIfEaNeKvU8hHrgQ2ZkuFcPlp45d1M6yOYp5em7qztEDaJBSQdZfRVX3vjxs6Lkw&sender_id=iSAYRA&message=132422&variables_values='+vm.customotp+'&route=dlt&numbers='+vm.phone).then(function (response) {
 if(response.data.message.includes('SMS sent successfully.')){
  vm.logintype='otp'


            console.log(response)
 vm.sendotpclicked=false
}else{
  alert(response.data.message)
}


 

 })

},
    account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/account' })

 }else{
this.loginbox=true
 }
    },
    


    renderper(price,offerprice){
       var x=(Number(price)-Number(offerprice))/Number(price)

var actprice=x*100
return Math.round(actprice)+'% OFF'
},

logins(){

 // console.log(this.$route.path)

 //this.$router.push({ path: '/'+this.$route.params.shopname+'/login',query:{refer:this.$route.path} })

},

logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 vm.user=false
}).catch(function(error) {
 
});
      },
    add(item){

 this.$emit('addcart',item)
  

 
    },
    sub(item){

 this.$emit('subcart',item)

 
  },

   }

   
    
 
  
}
</script>
 
 



// WEBPACK FOOTER //
// src/about.vue